<template>
  <div class="card-header border-bottom pt-1 pb-1">
    <h4 class="card-title">Employment</h4>
  </div>

  <div class="card-body mt-2">
    <form @submit.prevent="storeContact(employment)">
      <div class="row">
        <div class="col-sm-6 offset-md-3 col-12">
          <div class="row"  v-for="(emp, index) in employment">
            <div class="col-12">
              <div class="mb-1">
                <label class="col-form-label">Branch</label>
                <v-select
                    placeholder="Select Branch"
                    v-model="emp.employment_branch"
                    :options="branchList"
                    label="name"
                />
              </div>
            </div>

            <div class="col-12">
              <div class="mb-1">
                <label class="col-form-label">Division</label>
                <v-select
                    placeholder="Select Division"
                    v-model="emp.employment_division"
                    :options="divisionList"
                    label="name"
                />
              </div>
            </div>

            <div class="col-12">
              <div class="mb-1">
                <label class="col-form-label">Department</label>
                <v-select
                    placeholder="Select Department"
                    v-model="emp.employment_department"
                    :options="departmentList"
                    label="name"
                />
              </div>
            </div>

            <div class="col-12">
              <div class="mb-1">
                <label class="col-form-label">Business Unit</label>
                <v-select
                    placeholder="Select Business Unit"
                    v-model="emp.employment_business_unit"
                    :options="businessList"
                    label="name"
                />
              </div>
            </div>

            <div class="col-12">
              <div class="mb-1">
                <label class="col-form-label">Date Of Joining</label>
                <input type="date"  class="form-control" v-model="emp.employment_date_of_joining"
                       placeholder="Date Of Joining" />
              </div>
            </div>


            <div class="col-12">
              <div class="mb-1">
                <label class="col-form-label">Effective Date</label>
                <input type="date" id="full-name" required class="form-control" v-model="emp.employment_effective_date"
                       placeholder="Effective Date" />
              </div>
            </div>

            <div class="col-12">
              <div class="mb-1">
                <label class="col-form-label">Remarks</label>
                <input type="text" id="full-name" class="form-control" v-model="emp.employment_remarks"
                       placeholder="Remarks" />
              </div>
            </div>

            <div class="col-sm-6 offset-sm-3">
              <button type="submit" class="btn btn-primary me-1">Submit</button>
              <button @click="reset" type="reset" class="btn btn-outline-secondary">Reset</button>
            </div>

          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="card-body mt-2">
    <div class="card p-2" style="min-height: 200px">
      <div class="table-responsive">
        <table class="table">
          <thead>
          <tr>
            <th>Sl No.</th>
            <th>Effective Date</th>
            <th>Division</th>
            <th>Branch</th>
            <th>Department</th>
            <th>Business Unit</th>
            <th>Remarks</th>
            <th>Updated Date</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, i) in logList" :key="i">
            <td>{{ i+1 }}</td>
            <td>{{ item.employment_effective_date }}</td>
            <td>{{ item.employment_division_name }}</td>
            <td>{{ item.employment_branch_name }}</td>
            <td>{{ item.employment_department_name }}</td>
            <td>{{ item.employment_business_unit_name }}</td>
            <td>{{ item.employment_remarks }}</td>
            <td>{{ item.update_date }}</td>
          </tr>
          </tbody>
        </table>
        <p v-if="logList.length < 0" class="text-center mt-5">No data</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import {defineProps, onMounted, ref, watch} from "vue";
import {useRoute} from "vue-router";
import handleHrPayroll from '@/services/modules/hrPayroll/hrPayroll'
import handleDropdowns from "@/services/modules/dropdowns";

const emit = defineEmits(['storeContact'])
const props = defineProps({
  items: {
    type: Array
  }
})

const route = useRoute()
const { fetchContactItemLogs } = handleHrPayroll()
const { fetchDropdownList } = handleDropdowns()

let departmentList = ref([])
let branchList = ref([])
let logList = ref([])
let businessList = ref([])
let divisionList = ref([])

const employment  = ref([
    {
      employment: 'employment',
      employment_date_of_joining: '',
      employment_branch:'',
      employment_division:'',
      employment_department:'',
      employment_business_unit:'',
      employment_effective_date:'',
      employment_remarks:'',
    }
])

function getQuery() {
  return `?company_id=${route.params.companyId}`;
}

const storeContact = (employment) => {
  let items = employment.map(item => ({
      employment: item.employment,
      employment_date_of_joining:item.employment_date_of_joining,
      employment_branch_id: parseInt(item.employment_branch.id),
      employment_branch_name: item.employment_branch.name,
      employment_division_id: parseInt(item.employment_division.id),
      employment_division_name: item.employment_division.name,
      employment_department_id: parseInt(item.employment_department.id),
      employment_department_name: item.employment_department.name,
      employment_business_unit_id: parseInt(item.employment_business_unit.id),
      employment_business_unit_name: item.employment_business_unit.name,
      employment_effective_date: item.employment_effective_date,
      employment_remarks: item.employment_remarks,
    }));

  emit('storeContact', {'items':items})
}

const getLogList = async () => {
  let query = getQuery()
  query += `&contact_profile_id=${route.query.contactId}&field=employment`
  logList.value = []

  await fetchContactItemLogs(query).then(res => {
    if (!res.status){
      logList.value = []
      return
    }
    logList.value = res.data;
  }).catch(err => {
    console.log(err)
  })
}

const reset = () => {
  employment .value.length = 0;
}

watch(() => props.items, (newFormData) => {
  formDataSet();
});

const formDataSet = () => {
    if (props.items.length){
      employment.value = props.items.map(item => ({
        ...item,
        employment: item.employment,
        employment_date_of_joining:item.employment_date_of_joining,
        employment_branch: {
          id: parseInt(item.employment_branch_id),
          name: item.employment_branch_name
        },
        employment_division: {
          id: parseInt(item.employment_division_id),
          name: item.employment_division_name
        },
        employment_department: {
          id: parseInt(item.employment_department_id),
          name: item.employment_department_name
        },
        employment_business_unit: {
          id: parseInt(item.employment_business_unit_id),
          name: item.employment_business_unit_name
        },
        employment_effective_date: item.employment_effective_date,
        employment_remarks: item.employment_remarks,
      }));
    }
}

const getDropdownList = async () => {
  let query = getQuery();
  query += '&is_branch=1&is_division=1&is_department=1&is_business=1'

  branchList.value = []
  divisionList.value = []
  departmentList.value = []
  businessList.value = []

  await fetchDropdownList(query).then(res => {
    if (!res.status){
      return
    }

    let data = res.data;
    branchList.value = data.branch_list;
    divisionList.value = data.division_list;
    departmentList.value = data.department_list;
    businessList.value = data.business_list;
  }).catch(err => {
    console.log(err)
  })
}

onMounted(() => {
  getLogList();
  getDropdownList();
})

</script>
